import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DsSliderComponent } from "./ds-slider.component";
import { MatSliderModule } from "@angular/material/slider";

@NgModule({
  declarations: [DsSliderComponent],
  imports: [CommonModule, MatSliderModule],
  exports: [DsSliderComponent],
})
export class DsSliderModule {}
